
    const data = {"name":"src/core/icons/arrow-down-small","data":{"width":"11","height":"7","viewBox":"0 0 11 7","data":"<path pid=\"0\" d=\"M555.048 631.153a1 1 0 0 1-.744-.332l-4.5-5a1 1 0 1 1 1.487-1.337l3.757 4.174 3.756-4.174a1 1 0 1 1 1.487 1.337l-4.5 5a1 1 0 0 1-.743.332Z\" transform=\"translate(-549.548 -624.153)\" _fill=\"#041334\"/>","originalColors":[{"type":"fill","color":"#041334"}],"stopColors":[]}}

            export default data
            